// extracted by mini-css-extract-plugin
export default {"productGrid":"vZ-z","centerLink":"wZ-z","productSection":"xZ-z","item":"yZ-z","ctaButton":"zZ-z"};